import { Sidebar } from '@/components/layout/Sidebar';
import { ScrollArea } from '@/components/ui/scroll-area';

export const AppShell = ({ children }) => {
  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <div className="noise-overlay" />
      <Sidebar />
      <main className="flex-1 overflow-hidden">
        <ScrollArea className="h-full">
          <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-[1440px]">
            {children}
          </div>
        </ScrollArea>
      </main>
    </div>
  );
};
